import { CKButton } from '@clearkit/react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Subscribe } from 'unstated';

import ConfirmDialogContainer from '~/containers/ConfirmDialog';

export const ConfirmDialogBase = ({
  open,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText,
  cancelText = 'Cancel',
  confirmButtonVariant = 'red',
  buttonDisabled = false,
  contentClasses = undefined,
  ...props
}) => (
  <Dialog open={open} onBackdropClick={onCancel} {...props}>
    <DialogTitle disableTypography>{title}</DialogTitle>

    {message && (
      <DialogContent classes={{ ...contentClasses }}>{message}</DialogContent>
    )}

    <DialogActions>
      {onCancel === null ? null : (
        <CKButton onClick={onCancel} variant="simple">
          {cancelText}
        </CKButton>
      )}
      <CKButton
        onClick={onConfirm}
        disabled={!!buttonDisabled}
        variantColor={confirmButtonVariant}
        variant="bold">
        {confirmText}
      </CKButton>
    </DialogActions>
  </Dialog>
);

const ConfirmDialog = () => (
  <Subscribe to={[ConfirmDialogContainer]}>
    {(container) => {
      const { show, title, confirm, cancel, text } = container.state;
      return (
        <ConfirmDialogBase
          open={show}
          title={title}
          message={text}
          onConfirm={confirm}
          onCancel={cancel}
        />
      );
    }}
  </Subscribe>
);

ConfirmDialogBase.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cancelText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  buttonDisabled: PropTypes.bool,
  contentClasses: PropTypes.object,
};
ConfirmDialogBase.defaultProps = {
  open: false,
  confirmText: 'Continue',
  confirmButtonVariant: 'red',
  cancelText: 'Cancel',
  onCancel: () => {},
  onConfirm: () => {},
};

export default ConfirmDialog;
